import { SearchResourceType } from '@app/core/model/search/search-resource-type';
import { Constants } from '@app/core/utilities/constants';
import { ISearchDataSourceOptions } from './search.datasource';

const FILE_CHOOSER_RESOURCE_TYPES = new Set<SearchResourceType>([
  SearchResourceType.File,
  SearchResourceType.AppResultFile,
]);

/**
 * Applies file-chooser-specific search datasource defaults.
 *
 * By default file choosers omit sortBy so the search API uses its built-in ordering
 * (score desc, then datemodified desc, then id asc). Enable the FileChooserSortByModifiedOn
 * code feature to restore the legacy ModifiedOn default.
 */
export function mergeFileChooserSearchDataSourceOptions(
  resourceType: SearchResourceType,
  options: ISearchDataSourceOptions | undefined,
  sortByModifiedOnFallbackEnabled: boolean
): ISearchDataSourceOptions {
  if (!FILE_CHOOSER_RESOURCE_TYPES.has(resourceType)) {
    return options;
  }

  const merged: ISearchDataSourceOptions = { ...options };

  if (sortByModifiedOnFallbackEnabled) {
    if (!merged.defaultSortby) {
      merged.defaultSortby = Constants.ServerSortFields.ModifiedOn;
      merged.defaultSortDir = merged.defaultSortDir || Constants.ServerSortDirection.Desc;
    }
    return merged;
  }

  merged.useSearchDefaultSort = true;
  return merged;
}
